import {
  AuthenticationModuleClientFactory,
  AuthenticationModuleMiddlewareFactory,
  AuthenticationModuleServerFactory
} from '../types';

export const clientFactory: AuthenticationModuleClientFactory = authenticationModuleClient =>
  authenticationModuleClient;

export const serverFactory: AuthenticationModuleServerFactory = authenticationModuleServer =>
  authenticationModuleServer;

export const middlewareFactory: AuthenticationModuleMiddlewareFactory = authenticationModuleMiddleware =>
  authenticationModuleMiddleware;
